import { SchedulePageSkeleton } from "./SchedulePageSkeleton";
import { SchedulePageHeader } from "../../../../layout/schedule/SchedulePageHeader";
import { EventSchedule } from "../../../../layout/schedule/EventSchedule";
import { EmptyState } from "../../../../layout/EmptyState";
import { IconEmptySchedule } from "../../../../../styleguide/icons/icons";
import { useEvent } from "../EventProvider";
import { useMeta } from "hooks/useMeta";
import { useLocalizationContext } from "components/providers/LocalizationProvider";
import dayjs from "dayjs";
import { SHORT_DATE } from "utils/dates";
import { getEventMetadataDescription } from "utils/metadata";

const SchedulePage = () => {
    const event = useEvent();

    const { translate } = useLocalizationContext();
    const eventDate = dayjs(event?.date).format(SHORT_DATE);

    const translationProps = {
        prefix: "See the event schedule",
        eventName: event?.name,
        orgName: event?.organisation?.name,
        sportType: translate(event?.organisation?.sportType),
        eventDate: eventDate,
        eventLocation: event?.location?.placePredictionText,
    };
    useMeta({
        title: "event_schedule_public_meta_title",
        description: getEventMetadataDescription(translationProps),
        translationProps: {
            prefix: translate("Schedule"),
            eventName: event?.name,
            orgName: event?.organisation?.name,
            eventLocation: event?.location?.placePredictionText,
            eventDate: eventDate,
            sportType: translate(event?.organisation?.sportType),
        },
        skip: !event
    });

    if (!event) return <SchedulePageSkeleton/>;

    const showSchedule = !event.hideScheduledTime &&
        ["scheduled", "drawn", "upcoming"].indexOf(event.status) === -1 &&
        event.fullSchedule.podiums &&
        event.fullSchedule.podiums.some(podium => podium.heats.filter(h => h).length);

    return (
        <>
            <SchedulePageHeader event={event}/>
            {showSchedule ?
                <EventSchedule event={event}/> :
                <EmptyState
                    icon={<IconEmptySchedule/>}
                    text={event.hideScheduledTime ?
                        "This schedule is top secret material. The Event Director has opted to keep the schedule hidden for now." :
                        "We can tell you're excited for this event! The schedule will be available here once created by the Director."
                    }/>}
        </>
    );
};
export default SchedulePage;
